// Resolve the request language from the front-end page URL — the source of truth — rather
// than the mutable I18N_LANGUAGE localStorage flag, which can be stale (e.g. the user switches
// to EN, then types the Greek URL in the address bar). A stale value would otherwise drive the
// API culture segment + Accept-Language header and, for example, send confirmation emails in the
// wrong language (VA-10700). A culture-less URL (the Greek default site) resolves to Greek.
// Mirrors the VA-10481 findbar fix.
export const getUrlLanguage = () => (/^\/en(\/|$)/i.test(window.location.pathname) ? 'en' : 'el');
